import { render, staticRenderFns } from "./wjSpecial.vue?vue&type=template&id=649fad50&scoped=true"
import script from "./wjSpecial.vue?vue&type=script&lang=js"
export * from "./wjSpecial.vue?vue&type=script&lang=js"
import style0 from "./wjSpecial.vue?vue&type=style&index=0&id=649fad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fad50",
  null
  
)

export default component.exports